import React from 'react';
import PropTypes from 'prop-types';
import Header from '../common/Header';
import GlobalMenu from '../common/GlobalMenu';
import Content from './Content';
import Footer from '../common/Footer';

/**
 * Wrapper
 */
class Wrapper extends React.Component {

  render() {
    return (
      <div id="wrapper" className="fix_height sortgroup">
        <Header userName={this.props.data.userName} error={this.props.data.error} comactions={this.props.comactions} />
        <GlobalMenu />
        <Content data={this.props.data} actions={this.props.actions} comactions={this.props.comactions} />
        <Footer />
        <div id="bg" />
      </div>
    );
  }
}

Wrapper.propTypes = {
  data: PropTypes.any.isRequired,
  actions: PropTypes.any.isRequired,
  comactions: PropTypes.any.isRequired
};

export default Wrapper;
